import request from '@/utils/http'

/** 全题库 hover 单条题型 */
export interface PracticeType {
  termId: number
  shortType: string
  description: string
  totalScoreWeight: number
  aiTag: string | null
}

/** 全题库 hover 科目分组 */
export interface PracticeGroup {
  parentCode: string
  parentName: string
  types: PracticeType[]
}

/** 全题库 hover 响应 data  */
export interface PracticeHoverData {
  groups: PracticeGroup[]
}

/** 高频库 hover 命中档 */
export type HitLevel = 'HIGH' | 'MEDIUM' | 'NORMAL' | 'LOW'

/** 高频库 hover 单条题型 */
export interface HighFreqType {
  termId: number
  shortType: string
  totalCount: number
  sprintCount: number
  seasonHitCount: number
  hitLevel: HitLevel
  practiceLearned: number | null
  practiceProgress: number | null
  collectCount: number | null
}

/** 高频库 hover 科目分组 */
export interface HighFreqGroup {
  parentCode: string
  parentName: string
  types: HighFreqType[]
}

/** 高频库 hover 响应 data */
export interface HighFrequencyHoverData {
  sprintDateStart: string
  sprintDateEnd: string
  seasonStart: string
  seasonDays: number
  tips: string
  groups: HighFreqGroup[]
}

/** 全题库 hover（进入站点或首次 hover 调用，无需登录） */
export const getPracticeHoverApi = () => {
  return request.get<PracticeHoverData>('/api/nav/practiceHover')
}

/** 高频库 hover 统计面板 */
export const getHighFrequencyHoverApi = () => {
  return request.get<HighFrequencyHoverData>('/api/nav/highFrequencyHover')
}
